module.exports = __webpack_public_path__ + "img/academ.ccea804c.svg";